// theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "roboto, sans-serif", // Change font globally
  },
  palette: {
    primary: {
      main: '#59A77A', // Change primary color (buttons, icons etc.)
    }
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          //color: '#59A77A', // Change default color of icons
          //backgroundColor: 'white',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#59A77A',
        },
        contained: {
           color: 'white',
        }
      },
    },
    MuiGrid: {
        styleOverrides: {
            root: {
                fontFamily: "roboto, sans-serif",
            },
        },
    },
  },
});

export default theme;
